import type {
  ClientChatMessage,
  ClientMediaItem
} from '@DigitaleDoerfer/digitale-doerfer-api';
import { setImageAsync, setStringAsync, StringFormat } from 'expo-clipboard';

import { dayjs } from '@/time';

export const copyTextToClipboard = async (
  message: ClientChatMessage
): Promise<void> => {
  const content = message.message;
  if (content) {
    await setStringAsync(content, {
      inputFormat: StringFormat.PLAIN_TEXT
    });
  }
};

export const copyImageToClipboard = async (
  mediaItem: ClientMediaItem
): Promise<void> => {
  const imageUrl = mediaItem?.urls.original;
  if (imageUrl) {
    const response = await fetch(imageUrl);
    const imageData = await convertBlobToBase64(await response.blob());
    await setImageAsync(imageData);
  }
};

export const convertBlobToBase64 = (blob: Blob): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.addEventListener('error', (e) =>
      reject(new Error('Failed to read data as url: ' + e.type))
    );
    reader.addEventListener('load', () => {
      const dataUrl = reader.result as string;
      const base64Data = dataUrl.slice(dataUrl.indexOf(',') + 1);
      resolve(base64Data);
    });
    reader.readAsDataURL(blob);
  });

export const needsSeparator = (
  messages: ClientChatMessage[],
  messageIndex: number
): boolean => {
  if (messageIndex >= messages.length - 1) {
    // the last message in array (top message in the FlatList) has alway a day separator
    return true;
  }
  const currentMessage = messages[messageIndex];
  const previousMessage = messages[messageIndex + 1];
  return !dayjs(currentMessage.sentTime).isSame(
    dayjs(previousMessage.sentTime),
    'day'
  );
};
